import React from "react";
import { useEffect, useState, useMemo } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import { grey } from "@mui/material/colors";
import InputAdornment from "@mui/material/InputAdornment";
import InputLabel from "@mui/material/InputLabel";
import Button from "@mui/material/Button";
import moment from "moment";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import Autocomplete from "@mui/material/Autocomplete";
import IconButton from "@mui/material/IconButton";
import InfoIcon from "@mui/icons-material/Info";
import { UrlApi } from "../../../services/apirest";
import Alert from "@mui/material/Alert";
import { v4 as uuidv4 } from "uuid";

//Componentes PROPIOS
import ModalInfoDireccion from "../clientes/pedidos/altapedido/ModalInfoDireccion";
import Notify from "../../Notify";
import ConfirmDialog from "../../../components/ConfirmDialog";
import BarraDatosPedido from "../clientes/pedidos/altapedido/BarraDatosPedido";
import { putData, getData } from "../../../services/library";
import ModalObservacionesInternas from "./ModalObservacionesInternas";

function EditarPedido5(props) {
  const [datosPedido, setDatosPedido] = useState(props.datos);
  const [origenPedido, setOrigenPedido] = useState([{}]);
  const [direcciones, setDirecciones] = useState();
  const [tanques, setTanques] = useState([{}]); // aca guardo los tanques que me traigo
  //seleccionados
  const [sucursales, setSucursales] = useState([{}]);
  const [direccion, setDireccion] = useState(null); //Aca se guardaran los datos de la direccion de entrega del pedido, para poder mostrarlos en pantalla.
  const [tanqueSel, setTanqueSel] = useState(null);

  //Pantalla
  const [showInfoDireccion, setShowInfoDireccion] = useState(false);
  const [disBtnGuardar, setDisBtnGuardar] = useState(false);

  const [segmentos, setSegmentos] = useState([]);
  const [segSelected, setSegselectd] = useState(null);
  const [modalObservaciones, setmodalObservaciones] = useState(false);

  const [condiciones, setCondiciones] = useState([]);
  const [condSelected, setcondSelected] = useState(null);
  const [modoEntrada, setModoEntrada] = useState(null); // Puede ser "litros", "cantidad", o "porcentaje"

  // GUARDO CAPACIDADES DE TANQUES SEGUN ESTEN SOLOS O EN BATERUA
  const [capMaxKg, setCapMaxKg] = useState(null); // Capacidad maxima del tanque o la bateria en Kg
  const [kgCarga, setkgCarga] = useState(props.datos.kgacargar);

  //Una vez que seleccioné un tanque, me fijo si ese tanque está en bateria
  const [tanquesxbat, setTanquesxbat] = useState(); //en este estado,

  const [litrosCarga, setLitrosCarga] = useState(
    datosPedido.ltsacargar ? datosPedido.ltsacargar :
    props.datos.kgacargar && direccion && direccion[0]
      ? (
        props.datos.kgacargar /
        (props.datos.id_empresa === 4
          ? direccion[0].densidad_autogas
          : direccion[0].densidad_hipergas)
      ).toFixed(0)
      : null
  );

  const [precio, setPrecio] = useState([]); //donde guardo la lista de precios que obtengo del back
  const [precioIva, setPrecioIva] = useState(0);
  const [precionormal, setPrecioNormal] = useState(0);

  const [alertKg, setAlertKg] = useState(false); // Estado que muestra una alerta si se exceden los kg solicitados , si el estado del pedido es aprobado/asignado
  const [confirmDialogKG, setConfirmDialogKG] = useState();
  const [densidad, setDensidad] = useState(null);


  const selectedSegmento = useMemo(() => {
    return segmentos ? segmentos.find((s) => s.id === datosPedido.id_segmento) : null;
  }, [datosPedido.id_segmento, segmentos]);

  const selectedCond = useMemo(() => {
    return condiciones ? condiciones.find((c) => c.id === datosPedido.id_condicionpago) : null
  }, [datosPedido.id_condicionpago, condiciones]);

  const getPrecios = async (idDireccion) => {
    if (!direccion || !segSelected || !props.datos.id_empresa) return;

    try {
      let url;
      if (props.datos.precio_especial === 1) {
        url = `/precios_especiales/vigente/cliente/${props.datos.id_cliente}`;
        // console.log("URL precio especial", url);

        const response = await fetch(UrlApi + url);
        const data = await response.json();
        setPrecio(data);
        // if (data.length === 0) {
        //   setdialogPrecioEspecial(true);
        // }
      } else {
        url = `/lista_precios/fechavigente/${props.datos.id_empresa}/${props.datos.id_sucursal_cliente}/${segSelected.id}/${direccion[0]?.id_producto}`;
        // console.log("props.datos", props.datos);

        // console.log("URL", url);
        const response = await fetch(UrlApi + url);
        const data = await response.json();
        // console.log("data", data);

        setPrecio(data);
        // if (data.length === 0) {
        //   setdialogListaPrecio(true);
        // }
      }
    } catch (error) {
      console.error("Error obteniendo precios:", error);
    }
  };

  const setearValores = async () => {
    if (precio) {
      // console.log("unidad de facturacion",props.datos.unidad_fact);

      if (props.datos.unidad_fact === 216) {
        let precio_sinIva = precio[0]?.precio_litro_sin_iva ?? precio[0]?.lt_sin_iva;
        let precio_conIva = precio[0]?.precio_litro_con_iva ?? precio[0]?.lt_con_iva;
        setPrecioIva(precio_conIva);
        setPrecioNormal(precio_sinIva);
      } else if (props.datos.unidad_fact === 215) {
        let precio_sinIva = precio[0]?.precio_kilo_sin_iva ?? precio[0]?.kg_sin_iva;
        let precio_conIva = precio[0]?.precio_kilo_con_iva ?? precio[0]?.kg_con_iva;
        setPrecioIva(precio_conIva);
        setPrecioNormal(precio_sinIva);
      }
    }
  };

  //---------------------------------------------------------------------------------------------------------------------------------------------------------//
  useEffect(() => {
    if (selectedSegmento) {
      setSegselectd(selectedSegmento);
    }
  }, [selectedSegmento]);

  useEffect(() => {
    if (selectedCond) {
      setcondSelected(selectedCond)
    }
  }, [selectedCond])

  //Seteo en tanque y en direcciones, todos los datos de sus respectivos registros
  useEffect(() => {
    direcciones &&
      setDireccion(
        direcciones.filter(
          (direccion) => direccion.id === datosPedido.id_direccionentrega
        )
      );
  }, [direcciones]);

  useEffect(() => {
    getData('/segmentos', setSegmentos);
    getData('/condicion_pago', setCondiciones)
  }, []);

  useEffect(() => {
    tanques &&
      setTanqueSel(
        tanques.filter((tanque) => tanque.id_tanque === datosPedido.id_tanque)
      );
  }, [tanques]);

  useEffect(() => {
    getData("/tanques/dirent/" + datosPedido.id_direccionentrega, setTanques);
    getData(
      "/direccionesentrega/cli/" + datosPedido.id_cliente,
      setDirecciones
    );
    getData("/desplegables/origenpedido", setOrigenPedido);
    getData("/sucursales/tipoPlanta", setSucursales);
  }, []);

  useEffect(() => {
    tanqueSel &&
      tanqueSel[0] &&
      getData("/tanques/bateria/" + tanqueSel[0].idbateria, setTanquesxbat);
  }, [tanqueSel]);

  useEffect(() => {
    // Si el tanque esta en bateria, sumo todas las capacidades
    if (tanquesxbat && tanquesxbat.length > 0) {
      const densidad = props.datos.id_empresa === 4
        ? direccion[0].densidad_autogas
        : direccion[0].densidad_hipergas;
      // console.log("densidad en bateria", densidad);

      //("Tanque en bateria")
      tanquesxbat &&
        setCapMaxKg(
          tanquesxbat
            .map((item) => item.capacidad * 1 * 1000 * 0.85 * densidad)
            .reduce((acumulador, valorActual) => acumulador + valorActual, 0)
            .toFixed(2)
        );
    }
    // si esta solo, nada
    if (tanquesxbat && tanquesxbat.length <= 0) {
      const densidad = props.datos.id_empresa === 4
        ? direccion[0].densidad_autogas
        : direccion[0].densidad_hipergas;
      // console.log("densidad", densidad);

      setCapMaxKg(
        (tanqueSel && tanqueSel[0].capacidad * 1 * 1000 * 0.85) * densidad
      );
    }
  }, [tanquesxbat, direccion]);

  useEffect(() => {
    if (direccion && direccion[0]) {
      definirKgACargar();
    }
  }, [tanquesxbat, datosPedido.cantidad, datosPedido.porcentaje, litrosCarga, tanqueSel, direccion]);

  useEffect(() => {
    if (direccion && direccion.length) {
      getPrecios();
    }
  }, [direccion]);

  useEffect(() => {
    precio && setearValores();
  }, [direcciones, precio]);

  useEffect(() => {
    if (direccion && direccion[0]) {
      setDensidad(
        props.datos.id_empresa === 1
          ? direccion[0].densidad_hipergas
          : direccion[0].densidad_autogas
      );
    } else {
      setDensidad(null); 
    }
  }, [direccion, props.datos.id_empresa]);

  //HAGO EL CALCULO
  const definirKgACargar = () => {
    const densidad =
      props.datos.id_empresa === 4
        ? direccion[0].densidad_autogas
        : direccion[0].densidad_hipergas;

    
    if (tanquesxbat && tanquesxbat.length <= 0) {
      if (datosPedido.cantidad) {
        setkgCarga(datosPedido.cantidad);
        datosPedido.porcentaje = null;
        datosPedido.litros = null;
      } else if (litrosCarga) {
        const kg = (litrosCarga * densidad).toFixed(0);
        setkgCarga(kg);
        datosPedido.cantidad = kg;
        datosPedido.porcentaje = null;
      } else if (datosPedido.porcentaje) {
        setkgCarga(
          (
            (tanqueSel[0].capacidad * 1 * 1000 * 0.85 -
              tanqueSel[0].capacidad *
              1 *
              1000 *
              ((datosPedido.porcentaje * 1) / 100)) *
            densidad
          ).toFixed(0)
        );
        datosPedido.cantidad = null;
        datosPedido.litros = null;
      } else {
        setkgCarga(null);
      }
    }

    // If the tank is in a battery
    if (tanquesxbat && tanquesxbat.length > 0) {
      if (datosPedido.cantidad) {
        setkgCarga(datosPedido.cantidad);
        datosPedido.porcentaje = null;
        datosPedido.litros = null;
      } else if (litrosCarga) {
        const kg = (litrosCarga * densidad).toFixed(0);
        setkgCarga(kg);
        datosPedido.cantidad = kg;
        datosPedido.porcentaje = null;
      } else if (datosPedido.porcentaje) {
        setkgCarga(
          tanquesxbat
            .map(
              (item) =>
                (item.capacidad * 1 * 1000 * 0.85 -
                  item.capacidad *
                  1 *
                  1000 *
                  ((datosPedido.porcentaje * 1) / 100)) *
                densidad
            )
            .reduce((acumulador, valorActual) => acumulador + valorActual, 0)
            .toFixed(0)
        );
        datosPedido.cantidad = null;
        datosPedido.litros = null;
      } else {
        setkgCarga(null);
      }
    }
  };

  //Funcion para almacenar los datos DEL PEDIDO
  const almacenar = (e) => {
    // setDatosPedido({
    //   ...datosPedido,
    //   [e.target.name]: e.target.value === "" ? null : e.target.value,
    // });
    const { name, value } = e.target;
    if (name === "litros") {
      setModoEntrada("litros");
      setLitrosCarga(value === "" ? null : value);
      setDatosPedido({
        ...datosPedido,
        cantidad: value && densidad ? (value * densidad).toFixed(0) : null,
        porcentaje: null,
      });
    } else if (name === "cantidad") {
      setModoEntrada("cantidad");
      setLitrosCarga((value/densidad).toFixed(0));
      setDatosPedido({
        ...datosPedido,
        cantidad: value === "" ? null : value,
        porcentaje: null,
      });
    } else if (name === "porcentaje") {
      setModoEntrada("porcentaje");
      // setLitrosCarga(null);
      setDatosPedido({
        ...datosPedido,
        porcentaje: value === "" ? null : value,
        cantidad: null,
      });
    } else {
      setDatosPedido({
        ...datosPedido,
        [name]: value === "" ? null : value,
      });
    }
  };

  const validateAndSave = (e) => {
    if (
      (props.datos.id_estado === 21 || props.datos.id_estado === 23) &&
      props.datos.kgacargar * 1 < kgCarga
    ) {
      e.preventDefault();
      setConfirmDialogKG(true);
    } else {
      guardarPedido(e);
    }
  };

  async function guardarPedido(e) {
    setDisBtnGuardar(true);
    putData(
      e,
      "/pedidos/" + datosPedido.id_pedido,
      {
        id_origen: datosPedido.id_origen,
        cantidad: datosPedido.cantidad === "" ? null : datosPedido.cantidad,
        porcentaje:
          datosPedido.porcentaje === "" ? null : datosPedido.porcentaje,
        id_tanque: tanqueSel.id_tanque,
        fecha_probable_entrega: datosPedido.fecha_probable_entrega,
        fecha_requerida: datosPedido.fecha_requerida,
        observaciones: datosPedido.observaciones,
        usuario_modifica: localStorage.getItem("user"),
        kgacargar: kgCarga,
        idsucursal_atiende: datosPedido.idsucursal_atiende,
        ltsacargar:litrosCarga,
        usuario_aumentakg:
          (props.datos.id_estado === 21 || props.datos.id_estado === 23) &&
            props.datos.kgacargar * 1 < kgCarga
            ? localStorage.getItem("user")
            : props.datos.usuario_aumentakg,
      },
      setNotificacion
    );
  }

  const handleClose = () => {
    if (props.handleCloseEdicion) {
      props.handleCloseEdicion();
      props.setShowTabs && props.setShowTabs(true);
    } else {
      props.editar(false);
      props.tabla(true);
      props.setShowTabs && props.setShowTabs(true);
    }
  };

  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };

  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });

  // useEffect(() => {
  //   setprecioIva(datosPedido.precio_iva * datosPedido.cantidad);
  //   setprecionormal(datosPedido.precio_siniva * datosPedido.cantidad);
  // }, [datosPedido]); 

  // console.log("precioIva", precioIva);
  // console.log("precioNormal", precionormal);
  // useEffect(() => {
  //   definirKgACargar();
  // }, [tanquesxbat, datosPedido.cantidad, datosPedido.porcentaje, tanqueSel]);

  // const calcularPrecios = () => {

  //   let precioConIva = 0;
  //   let precioSinIva = 0;
  //   let cantidadLitros = null;

  //   if (props.datos.uni_fact === 215) {
  //     precioConIva = props.datos.precio_iva;
  //     precioSinIva = props.datos.precio_siniva;
  //     setPrecioIva(precioConIva * (parseInt(kgCarga)));
  //     setPrecioNormal(precioSinIva * (parseInt(kgCarga)));

  //   } else if (props.datos.uni_fact === 216) {
  //     const densidad = direccion && direccion[0] && props.datos.id_empresa === 1
  //       ? direccion[0].densidad_hipergas
  //       : direccion[0].densidad_autogas;
  //     cantidadLitros = parseInt(kgCarga) / parseFloat(densidad);

  //     precioConIva = props.datos.precio_iva;
  //     precioSinIva = props.datos.precio_siniva;
  //     setPrecioIva(parseFloat(precioConIva) * (parseFloat(cantidadLitros)));
  //     setPrecioNormal(parseFloat(precioSinIva) * (parseFloat(cantidadLitros)));
  //   }
  // };

  // console.log("densidad", densidad);
  // console.log("precioiva", props.datos.precio_iva );
  // console.log("precionormal",  props.datos.precio_siniva);
  // console.log("unidad de facturacion", props.datos.uni_fact);
  // console.log("kgcarga", kgCarga ===null);
  // console.log("datos.porcentjae", props.datos.porcentaje);
  // console.log("props.datos.cantidad", props.datos.cantidad);
  // console.log("props.datos.kgacargar", props.datos.kgacargar);
  // console.log("kg a cargar", kgCarga);
  // console.log("props.datos", props.datos);
  // console.log("kg a cargar",parseInt(kgCarga));
  // console.log("cantidad litros", props.datos.uni_fact);
  // console.log("precio normal", precionormal);
  // console.log("preco iva", precioIva);
  // console.log("segSelected", segSelected);
  // console.log("props.datos", props.datos);
  // console.log("direccion",props.datos.precio_siniva);
  // console.log("tanque", tanqueSel);
  // props.datos&&  console.log("direccion", direccion);
  // console.log("precio", precio);
  // console.log("ltsacargar", datosPedido.ltsacargar);
  // console.log("valor de litros carga",litrosCarga);
  
  // useEffect(() => {
  //   if (kgCarga === null) {
  //     setPrecioIva(0);
  //     setPrecioNormal(0);
  //   } else {
  //     direccion && calcularPrecios()
  //   }
  // }, [kgCarga]);

  return (
    <div>
      {notificacion && notificacion.open ? (
        <Notify
          mensaje={notificacion.mensaje}
          open={notificacion.open}
          color={notificacion.color}
          handleClose={handleClose}
          severity={notificacion.severity}
        />
      ) : null}
      {/* ALERT --> SE MUESTRA SI HAY UN ERROR EN LA API (NO SE CONECTA O ESTÁ MAL LA RUTA, ETC.) */}
      {/* {error && mensajeAlerta ? (
        <Alerta mensaje={mensajeAlerta} severity={"error"} />
      ) : null} */}
      {!!direccion && !!tanqueSel && tanqueSel[0] && (
        <BarraDatosPedido
          tanqueSel={tanqueSel[0]}
          tanquesxbat={tanquesxbat}
          capMaxKg={capMaxKg}
          kgCarga={kgCarga}
          sucursal={datosPedido.sucursal_atiende}
          condicionPago={datosPedido.condicion}
          direccion={direccion[0]}
          precionormal={precionormal}
          precioIva={precioIva}
          segSelected={segSelected}
          setSegselectd={setSegselectd}
          condSelected={condSelected}
          setcondSelected={setcondSelected}
          condicion={datosPedido.id_condicionpago}
          condiciones={condiciones}
          segmentos={segmentos}
          datosente={datosPedido.id_cliente}
        // getPrecios={getPrecios}
        />
      )}
      {/* INICIO DE FORMULARIO DE EDICIÓN */}
      {alertKg ? (
        <Box marginBottom={1}>
          <Alert
            severity="warning"
            onClose={() => {
              setAlertKg(false);
            }}
          >
            <strong>Atención!</strong> No se pueden aumentar los KG en un pedido
            una vez que este fue aprobado.
          </Alert>
        </Box>
      ) : null}
      <form onSubmit={validateAndSave}>
        <Box
          border={0.5}
          borderColor={grey[300]}
          backgroundColor="#F4F6F6"
          p={2}
          py={4}
        >
          <Grid container spacing={2} alignItems="center">
            {/* <Grid item xs={3}>
              <FormControl style={style} focused required disabled>
                <InputLabel>Origen Pedido</InputLabel>
                <Select
                  name="id_origen"
                  value={datosPedido.id_origen}
                  label="Origen Pedido"
                  onChange={almacenar}
                >
                  {origenPedido
                    ? origenPedido.map((elemento) => (
                        <MenuItem key={elemento.id} value={elemento.id}>
                          {elemento.valor}
                        </MenuItem>
                      ))
                    : null}
                </Select>
              </FormControl>
            </Grid> */}
            <Grid item xs={7.5}>
              <Autocomplete
                disabled
                value={direccion && direccion[0]}
                clearOnEscape
                defaultValue={direccion && direccion[0]}
                onChange={(event, newValue) => {
                  setDireccion(newValue);
                  // setCambieDir(true);
                  // setDialogPrecioEspecialCerrado(false);
                  // setDialogListaPrecioCerrado(false);
                }}
                options={direcciones}
                getOptionLabel={(direccion) => `${direccion.direccion_entrega} (${direccion.nombre_direccion})`}
                renderInput={(params) => (
                  <TextField
                    required
                    style={style}
                    focused
                    {...params}
                    label="Dirección De Entrega"
                    variant="outlined"
                  />
                )}
              />
            </Grid>
            <Grid item xs={1}>
              <Tooltip title="Ver Info Dirección De Entrega">
                <span>
                  <IconButton
                    disabled={!direccion}
                    size="large"
                    color="primary"
                    onClick={() => setShowInfoDireccion(true)}
                  >
                    <InfoIcon fontSize="inherit" />
                  </IconButton>
                </span>
              </Tooltip>
            </Grid>

            <Grid item xs={3.5}>
              <Autocomplete
                disabled
                value={tanqueSel && tanqueSel[0]}
                clearOnEscape
                defaultValue={tanqueSel && tanqueSel[0]}
                onChange={(event, newValue) => {
                  // console.log(newValue);
                  setTanqueSel(newValue);
                }}
                options={tanques}
                getOptionLabel={(tanque) => tanque.nro_serie}
                renderInput={(params) => (
                  <TextField
                    required
                    style={style}
                    focused
                    {...params}
                    label="Tanque"
                    variant="outlined"
                  />
                )}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                style={style}
                required={
                  (!datosPedido.cantidad && !datosPedido.porcentaje) ||
                  (datosPedido.cantidad && !datosPedido.porcentaje)
                }
                disabled={
                  datosPedido.porcentaje !== null &&
                  datosPedido.porcentaje !== ""
                }
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                inputProps={{
                  maxLength: 5,
                  readOnly: !tanqueSel,
                }} //solo 2 numeros
                error={
                  datosPedido.cantidad &&
                  capMaxKg &&
                  (datosPedido.cantidad * 1 === 0 ||
                    datosPedido.cantidad > capMaxKg * 1)
                }
                helperText={
                  datosPedido.cantidad &&
                    capMaxKg &&
                    (datosPedido.cantidad * 1 === 0 ||
                      datosPedido.cantidad > capMaxKg * 1)
                    ? `Máximo: ${capMaxKg} kg. Mínimo: 0 kg.`
                    : ""
                }
                focused
                color="primary"
                placeholder="Cantidad en kg"
                name="cantidad"
                label="Cantidad en kg"
                onChange={almacenar}
                value={datosPedido.cantidad}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">kg</InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                style={style}
                required={
                  (!datosPedido.cantidad && !datosPedido.porcentaje && !litrosCarga) ||
                  (modoEntrada === "litros" && !datosPedido.cantidad && !datosPedido.porcentaje)
                }
                disabled={modoEntrada !== "litros" && (datosPedido.porcentaje || datosPedido.cantidad) || !densidad || !direccion || !tanqueSel}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                inputProps={{
                  maxLength: 5,
                  readOnly: !tanqueSel || !direccion || !densidad,
                }}
                error={
                  litrosCarga &&
                  capMaxKg &&
                  densidad &&
                  (litrosCarga * 1 === 0 || litrosCarga * densidad > capMaxKg * 1)
                }
                helperText={
                  litrosCarga &&
                    capMaxKg &&
                    densidad &&
                    (litrosCarga * 1 === 0 || litrosCarga * densidad > capMaxKg * 1)
                    ? `Máximo: ${(capMaxKg / densidad).toFixed(2)} lts. Mínimo: 0 lts.`
                    : ""
                }
                focused
                color="primary"
                placeholder="Cantidad en litros"
                name="litros"
                label="Cantidad en litros"
                onChange={almacenar}
                value={litrosCarga || ""}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">lts</InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                style={style}
                required={
                  (!datosPedido.cantidad && !datosPedido.porcentaje) ||
                  (datosPedido.porcentaje && !datosPedido.cantidad)
                }
                disabled={datosPedido.cantidad}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                inputProps={{
                  maxLength: 2,
                  readOnly: !tanqueSel,
                }} //solo 2 numeros
                focused
                color="primary"
                placeholder="Porcentaje"
                name="porcentaje"
                error={datosPedido.porcentaje && datosPedido.porcentaje >= 85}
                helperText={
                  datosPedido.porcentaje >= 85 ? "Debe ser menor al 85%" : ""
                }
                label="Porcentaje"
                onChange={almacenar}
                value={datosPedido.porcentaje}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">%</InputAdornment>
                  ),
                }}
              />
            </Grid>
            {/* <Grid item xs={2}>
              <TextField
                style={style}
                disabled={true} // Para habilitar cuando haya una listad de precios, tengo q pasar disabled={disabledpesos}
                type="number"
                focused
                color="primary"
                placeholder="Pesos"
                name="pesos"
                id="pesos"
                label="Pesos "
                onChange={almacenar}
                value={datosPedido.pesos}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">$</InputAdornment>
                  ),
                }}
              />
            </Grid> */}
            {/* <Grid item xs={3}>
              <TextField
                style={style}
                focused
                color="primary"
                id="date"
                label="Fecha requerida de entrega"
                name="fecha_requerida"
                type="date"
                onChange={almacenar}
                value={moment(datosPedido.fecha_requerida).format("YYYY-MM-DD")}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid> */}
            <Grid item xs={3}>
              <FormControl
                style={style}
                focused
                color="primary"
                required
                disabled={
                  datosPedido.id_estado !== 19 && datosPedido.id_estado !== 21
                }
              >
                <InputLabel>Atendido Por Sucursal: </InputLabel>
                <Select
                  name="idsucursal_atiende"
                  value={datosPedido.idsucursal_atiende}
                  onChange={almacenar}
                  label="Atendido Por Sucursal: "
                >
                  {sucursales
                    ? sucursales.map((sucursal) => (
                      <MenuItem key={sucursal.id} value={sucursal.id}>
                        {sucursal.nombre}
                      </MenuItem>
                    ))
                    : null}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={10}>
              <TextField
                style={style}
                focused
                color="primary"
                label="Observaciones"
                name="observaciones"
                onChange={almacenar}
                value={datosPedido.observaciones}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <Button
                variant="outlined"
                onClick={() => setmodalObservaciones(true)}> OBSERVACIONES INTERNAS</Button>
            </Grid>
          </Grid>
        </Box>
        <Box>
          <Grid
            mt={3}
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Button
              variant="contained"
              color="error"
              onClick={() => handleClose()}
            >
              Volver
            </Button>
            <Button
              disabled={
                (datosPedido.cantidad &&
                  (datosPedido.cantidad * 1 === 0 ||
                    datosPedido.cantidad * 1 > capMaxKg)) ||
                (datosPedido.porcentaje && datosPedido.porcentaje >= 85) ||
                (!kgCarga ||
                  kgCarga === 0)

              }
              variant="contained"
              type="submit"
              color="success"
            >
              Guardar Pedido
            </Button>
          </Grid>
        </Box>
      </form>
      {showInfoDireccion ? (
        <ModalInfoDireccion
          direccion={direccion[0]}
          open={showInfoDireccion}
          setOpen={setShowInfoDireccion}
        />
      ) : null}
      {confirmDialogKG ? (
        <ConfirmDialog
          open={confirmDialogKG}
          setOpen={setConfirmDialogKG}
          title={"Guardar Modificación De Pedido"}
          text={
            "Usted ha aumentado los kilogramos del pedido luego de que ha sido aprobado. Confirme para guardar."
          }
          notificacion={notificacion} //Estos parámetros que seteo en la función en "library", los tengo que pasar porque determinan si se mostrará o no la notificación, que está ubicada en "notify"
          guardar={guardarPedido}
          atras={() => {
            setConfirmDialogKG(false);
            setNotificacion({ open: false });
            handleClose();
          }}
        />
      ) : null}
      {modalObservaciones ?
        <ModalObservacionesInternas
          datosPedidos ={props.datos}
          open={modalObservaciones}
          setOpen={setmodalObservaciones}
          setDatosPedido ={setDatosPedido}
          />
      :null}

      {/* {dialogPrecioEspecial ? (
        <AddPrecioEspecialDireccion
        open={dialogListaPrecio}
        onClose={handleCloseDialogListaPrecio}
        setOpen={setdialogListaPrecio}
        direccion={direccion}
        datos={props.datos}
        actualizar={getPrecios}
        // datosente={getEmpresa}
        // empresa={empresaCli}
        segmento={segmentos}
        segSelected={segSelected}
        setSegselectd={setSegselectd}
        />
      ) : null}

      {dialogListaPrecio ? (
        <ModalAddlistaprecio
          open={dialogListaPrecio}
          onClose={handleCloseDialogListaPrecio}
          setOpen={setdialogListaPrecio}
          direccion={direccion}
          datos={props.datos}
          actualizar={getPrecios}
          // datosente={getEmpresa}
          empresa={props.datos}
          segmento={segmentos}
          segSelected={segSelected}
          setSegselectd={setSegselectd}
        />
      ) : null} */}

    </div>
  );
}

export default EditarPedido5;

//----- Component --------------------------------------------------------/
// Developer     : Candela Grosso
// Creation Date : 23/4/2025
// Version       : 1
// Description   : Este es un componente para cargar pedidos a un cliente a través de un formulario dinámico donde el usuario podrá cargar mas de uno a distintas direcciones o a distintos tanques... de la version original "Addpedidos4" la modificacion mas grande es esa- se agregó la opción pago anticipado, la posibilidad de ingresar tanto en kilos como en litros lo que se le va a entregar al cliente (aunque al momento de guardar, lo hace en kilos), observaciones internas que son para los usuarios de granel.
//Las observaciones van a estar relacionadas con un uuid porque la idea es poder poner 1 o mas segun sea necesario.-
//LO QUE FALTA: un campo donde ingresar el monto que el cliente quiere pagar y que calcule cuanto es
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   :
// Change by     :
// Change description:
//========================================================================/